export default __webpack_public_path__ + "static/media/add-color.cd79d249.svg";